/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';

export type CrossOwnerDocsNotifyClosePartialUpdateRequest = {} | null | undefined;
export type CrossOwnerDocsNotifyClosePartialUpdateResponse = any;

export type CrossOwnerDocsNotifyClosePartialUpdateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this doc.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * PATCH /dmx-server/cross_owner_docs/{id}/notify_close/
 *
 * ```yaml
 * operationId: cross_owner_docs_notify_close_partial_update
 * description: Finalizuje odmítnutí až po úspěchu všech DMVS notifikací.
 * tags:
 *   - cross_owner_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const crossOwnerDocsNotifyClosePartialUpdateOperation = ({
  id,
  ...rest
}: CrossOwnerDocsNotifyClosePartialUpdateQuery) =>
  ({
    method: 'PATCH',
    path: `/dmx-server/cross_owner_docs/${id}/notify_close/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'PATCH';
    path: string & { _templateUrl: '/dmx-server/cross_owner_docs/{id}/notify_close/' };
  };

/**
 * PATCH /dmx-server/cross_owner_docs/{id}/notify_close/
 *
 * ```yaml
 * operationId: cross_owner_docs_notify_close_partial_update
 * description: Finalizuje odmítnutí až po úspěchu všech DMVS notifikací.
 * tags:
 *   - cross_owner_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const crossOwnerDocsNotifyClosePartialUpdate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: CrossOwnerDocsNotifyClosePartialUpdateQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<any>> => {
  const operation = crossOwnerDocsNotifyClosePartialUpdateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'PATCH',
    request,
    onUploadProgress,
    cancelToken,
  );
};
